/* eslint-disable */
import 'core-js/es/array';
import 'core-js/es/object';
import 'core-js/es/array/flat-map';
import 'zone.js'; // Included with Angular CLI.
(window as any).global = window;
